module.exports = __webpack_public_path__ + "img/end_position_icon.9970d866.svg";